export const SPACING = 8;

export const BASEFONTSIZE = 750;
